module.exports = __webpack_public_path__ + "static/img/P2.deff665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/P2.png
// module id = fYu6
// module chunks = 0